import { SideBarButtonOptions } from '../class/sidebar';

export const PreConfigButton1: SideBarButtonOptions = {
  level: 1,
};

export const PreConfigButton2: SideBarButtonOptions = {
  level: 2,
};
export const PreConfigButton3: SideBarButtonOptions = {
  level: 3,
};
